exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tab-pane[data-v-ccc53008] {\n  padding: 0;\n}\n.tab-pane.active .tab[data-v-ccc53008] {\n  background-color: #e9f1fb;\n  color: #085FCE;\n}\n.tab-content[data-v-ccc53008] {\n  width: 100%;\n  background-color: #e9f1fb;\n  display: none;\n}\n.tab-content.active[data-v-ccc53008] {\n  display: flex;\n}", ""]);

// exports
